module.exports = "\r\n\r\n\r\n <div class=\"footer\">\r\n                    <div class=\"pull-right\">\r\n\r\n                    </div>\r\n                    <div>\r\n                        <strong>{{copyRight}}</strong> {{name}}\r\n                    </div>\r\n                </div>\r\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/global/footer.component.html
// module id = ../../../../../src/app/global/footer.component.html
// module chunks = main